import get from 'lodash/get'
import uniq from 'lodash/uniq'

export default function checkInvitationErrors({
  staticData,
  segments,
  selectedEpls,
  isFollowUp
}) {
  const { eplStatuses } = staticData.names
  const { EPL_STATUSES, REPLY_STATUSES } = staticData.CONST
  const { DO_NOT_CONTACT } = staticData.CONST.EXPERT_STATUSES

  const eplsWithEmailsMissing = selectedEpls.filter(
    eplModel => !eplModel.epl.expert.email
  )
  const eplsWithInvalidStatuses = selectedEpls.filter(
    eplModel => eplModel.epl.eplStatusId > EPL_STATUSES.REQUESTED
  )

  const doNotContactEPLs = selectedEpls.filter(
    e => e.epl.expert.expert.expertStatusId === DO_NOT_CONTACT
  )

  const notInterestedEPLs = selectedEpls.filter(
    e => e.epl.replyStatusId === REPLY_STATUSES.NOT_INTERESTED
  )

  const errorMessages = []
  const segmentErrors = []

  const segmentIds = uniq(
    selectedEpls.map(({ epl: { segmentId } }) => segmentId)
  )
  if (segmentIds.length > 1) {
    errorMessages.push(
      'Experts can only be invited into a single segment at a time.'
    )
  } else {
    const segment = segments.find(s => s.id === segmentIds[0])

    if (!segment.expertBrief) {
      segmentErrors.push('expertBrief')
    }

    if (!get(segment, 'screeningQuestions.length')) {
      segmentErrors.push('Screening questions')
    }

    if (!segment.employees.length) {
      segmentErrors.push('Assigned associates')
    }
  }

  const eplsHaveErrors =
    eplsWithEmailsMissing.length > 0 ||
    eplsWithInvalidStatuses.length > 0 ||
    doNotContactEPLs.length > 0 ||
    (isFollowUp && notInterestedEPLs.length > 0)

  if (!eplsHaveErrors && !segmentErrors.length && !errorMessages.length) {
    return { eligible: true, errors: null }
  }

  if (segmentErrors.length) {
    errorMessages.push(`
      <b>Missing info on the segment:</b>
      <br><br>
      ${segmentErrors.join(', ')}
    `)
  }

  if (eplsWithEmailsMissing.length > 0) {
    let message = '<b>Experts with missing emails:</b><br><br>'
    eplsWithEmailsMissing.forEach(eplModel => {
      message += `${eplModel.epl.expert.fullName}<br>`
    })
    errorMessages.push(message)
  }

  if (doNotContactEPLs.length > 0) {
    let message = '<b>Experts in Do not contact status:</b><br><br>'
    doNotContactEPLs.forEach(eplModel => {
      message += `${eplModel.epl.expert.fullName}<br>`
    })
    errorMessages.push(message)
  }

  if (isFollowUp && notInterestedEPLs.length > 0) {
    let message = '<b>Experts in Not interested reply status:</b><br><br>'
    notInterestedEPLs.forEach(eplModel => {
      message += `${eplModel.epl.expert.fullName}<br>`
    })
    errorMessages.push(message)
  }

  if (eplsWithInvalidStatuses.length > 0) {
    let message = '<b>Experts with invalid statuses:</b><br><br>'
    eplsWithInvalidStatuses.forEach(eplModel => {
      const expertName = eplModel.epl.expert.fullName
      const statusName = eplStatuses[eplModel.epl.eplStatusId]
      message += `${expertName} - ${statusName}<br>`
    })
    errorMessages.push(message)
  }

  return { eligible: false, errors: errorMessages }
}
